exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../../../../../node_modules/css-loader/index.js!vue-directive-tooltip/css/index.css"), "");

// module
exports.push([module.id, "p[data-v-161c4cbc] {\n  padding: 1.2em 0;\n}\n.reason-wrap[data-v-161c4cbc] {\n  padding: 0.5em 0;\n}\n.submit-buttons[data-v-161c4cbc] {\n  padding-top: 2em;\n}\ntextarea[data-v-161c4cbc] {\n  margin-top: 0.5em;\n  margin-left: 1.7em;\n}\n", ""]);

// exports
